export type Density = 'compact' | 'comfortable';

export function getInitialDensity(): Density {
  const stored = localStorage.getItem('cs-density');
  return stored === 'compact' || stored === 'comfortable' ? stored : 'comfortable';
}

export function applyDensity(d: Density): void {
  document.documentElement.setAttribute('data-density', d);
  localStorage.setItem('cs-density', d);
}
